module.exports = __webpack_public_path__ + "static/media/KI.80e19e9b.svg";